<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          {{ route.params.id ? 'Editar Categoria de Avaliação' : 'Nova Categoria de Avaliação' }}
        </h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarCategoria" @cancel="voltar">
        <!-- Dados da Categoria -->
        <FormSection title="Informações da Categoria">
          <InputField
            v-model="categoria.categoria"
            label="Nome da Categoria <span class='required'>*</span>"
            id="categoria"
            placeholder="Digite o nome da categoria"
            required
            :class="{ 'error-input': errors.categoria }"
            width="400px"
          />
        </FormSection>
      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import InputField from "@/components/Layout/InputField.vue";
  import FormSection from "@/components/Layout/FormSection.vue";
  import BaseForm from "@/components/Layout/BaseForm.vue";
  import axios from "@/services/axios";
  
  export default {
    components: { InputField, FormSection, BaseForm },
    setup() {
      const route = useRoute();
      const router = useRouter();
  
      const categoria = reactive({
        id: null,
        categoria: "",
      });
  
      const errors = reactive({});
      const formTouched = ref(false);
      const isSubmitting = ref(false);
  
      const validateForm = () => {
        errors.categoria = categoria.categoria.trim() ? "" : "O nome da categoria é obrigatório.";
      };
  
      const isFormValid = computed(() => {
        return categoria.categoria.trim() !== "" && !Object.values(errors).some(error => error);
      });
  
      const novaCategoria = () => {
        formTouched.value = false;
        isSubmitting.value = false;
        Object.assign(categoria, {
          categoria: "",
        });
        for (const key in errors) {
          if (Object.hasOwn(errors, key)) errors[key] = "";
        }
      };
  
      const salvarCategoria = async () => {
        if (isSubmitting.value) return;
  
        validateForm();
  
        if (!isFormValid.value) {
          console.error("O formulário contém erros:", errors);
          return;
        }
  
        isSubmitting.value = true;
        try {
          const method = categoria.id ? "put" : "post";
          const url = categoria.id
            ? `/configuracoes/parametros-avaliacoes/categorias/${categoria.id}`
            : "/configuracoes/parametros-avaliacoes/categorias";
  
          await axios[method](url, {
            categoria: categoria.categoria,
          });
  
          router.push("/configuracoes/parametros-avaliacoes/categorias");
        } catch (error) {
          console.error("Erro ao salvar categoria:", error);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/configuracoes/parametros-avaliacoes/categorias");
      };
  
      onMounted(async () => {
        const categoriaId = route.params.id;
  
        if (categoriaId) {
          try {
            const response = await axios.get(`/configuracoes/parametros-avaliacoes/categorias/${categoriaId}`);
            Object.assign(categoria, response.data);
          } catch (error) {
            console.error("Erro ao carregar categoria:", error);
          }
        } else {
          novaCategoria();
        }
      });
  
      return {
        categoria,
        errors,
        isFormValid,
        formTouched,
        isSubmitting,
        salvarCategoria,
        voltar,
        route,
      };
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .error-input {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
  }
  </style>
  